/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export namespace Types {
  export type CountryName = 'United States' | 'Canada';
}

export const UNITED_STATES = 'United States';
export const CANADA = 'Canada';
